<template>
  <div class="ag-gallery">
    <div class="ag-search-row">
      <div class="ag-search">
        <span
          class="ag-search-icon"
          aria-hidden="true">
          <icon name="search"/>
        </span>
        <input
          ref="input"
          v-model="searchQuery"
          type="search"
          aria-label="Search"
          placeholder="Search"
          @input="checkQueryValue"
          @keydown.enter.stop="changeQueryValue">
        <button
          v-show="searchQuery != ''"
          type="button"
          class="ag-search-clear"
          aria-label="Clear search"
          title="Clear search"
          @click="clearValue($event)">
          <icon name="close-icon"/>
        </button>
      </div>
      <span
        v-if="searchQuery"
        class="ag-search-results">Results for “{{ searchQuery }}”</span>
    </div>

    <div
      id="gallery-audios"
      class="ag-list">
      <Spinner
        v-show="loader"
        :speed="1"
        size="small"
        message="Loading..."
        class="inner-Loader"/>

      <div
        v-if="!loader && !hasAudios"
        class="ag-empty">
        No audio files found.
      </div>

      <div
        v-for="(audio, index) in getFilteredAudios"
        :key="audioKey(audio) || index"
        class="ag-row-wrap">
        <div
          v-if="audio"
          class="ag-row"
          @click="insertAudioToCanvas(audio)">
          <button
            type="button"
            class="ag-toggle"
            :class="{ 'is-playing': isPlaying(audio) }"
            :aria-label="isPlaying(audio) ? 'Pause' : 'Play'"
            @click.stop="togglePreview(audio)">
            <svg
              v-if="!isPlaying(audio)"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              aria-hidden="true">
              <path
                d="M2.4 1.15v7.7L8.7 5z"
                fill="currentColor"/>
            </svg>
            <svg
              v-else
              width="10"
              height="10"
              viewBox="0 0 10 10"
              aria-hidden="true">
              <path
                d="M2.1 1.3h1.9v7.4H2.1zM5.9 1.3h1.9v7.4H5.9z"
                fill="currentColor"/>
            </svg>
          </button>
          <div class="ag-main">
            <span class="ag-name">{{ audio.Name }}</span>
            <span
              v-if="isPlaying(audio)"
              class="ag-progress">
              <span :style="{ width: progress + '%' }"/>
            </span>
          </div>
          <span class="ag-time">{{ formatDuration(durations[audioKey(audio)]) }}</span>
          <button
            type="button"
            class="ag-delete"
            aria-label="Delete"
            title="Delete"
            @click.stop="deleteAudioFromMyGallery(audio.VirtualPath)">
            <icon name="trash"/>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  name:       'StockAudioBox',
  components: { Spinner },
  data() {
    return {
    /* audios: [{
        Id: "b0161ac9-e2b4-453d-b9ce-46f603b9f4dc",
        Name: "Ed_Sheeran_-_Perfect5.mp3",
        DefaultImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect5.mp3#b0161ac9-e2b4-453d-b9ce-46f603b9f4dc",
        HighResImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect5.mp3",
        ImageType: 11,
        CropOption: 0,
        ImageThumbnailPath: "https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-Ed_Sheeran_-_Perfect5.mp3",
        ImageThumbnailPathV2: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect5.mp3#b0161ac9-e2b4-453d-b9ce-46f603b9f4dc",
        ImageThumbnailPathV2Width: 0,
        ImageThumbnailPathV2Height: 0,
        HighResV2Width: 0,
        HighResV2Height: 0,
        Description: null
      },
    {
      Id: "b0161ac9-e2b4-453d-b9ce-46f603b9f4dc",
          Name: "Ed_Sheeran_-_Perfect5.mp3",
        DefaultImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect5.mp3#b0161ac9-e2b4-453d-b9ce-46f603b9f4dc",
        HighResImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect5.mp3",
        ImageType: 11,
        CropOption: 0,
        ImageThumbnailPath: "https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-Ed_Sheeran_-_Perfect5.mp3",
        ImageThumbnailPathV2: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect5.mp3#b0161ac9-e2b4-453d-b9ce-46f603b9f4dc",
        ImageThumbnailPathV2Width: 0,
        ImageThumbnailPathV2Height: 0,
        HighResV2Width: 0,
        HighResV2Height: 0,
        Description: null
    },
    {
      Id: "3038eacc-57a8-41dd-9199-d23e4711b087",
          Name: "Ed_Sheeran_-_Perfect4.mp3",
        DefaultImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect4.mp3#3038eacc-57a8-41dd-9199-d23e4711b087",
        HighResImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect4.mp3",
        ImageType: 11,
        CropOption: 0,
        ImageThumbnailPath: "https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-Ed_Sheeran_-_Perfect4.mp3",
        ImageThumbnailPathV2: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect4.mp3#3038eacc-57a8-41dd-9199-d23e4711b087",
        ImageThumbnailPathV2Width: 0,
        ImageThumbnailPathV2Height: 0,
        HighResV2Width: 0,
        HighResV2Height: 0,
        Description: null
    },
    {
      Id: "b4e75dcd-e516-4ead-b755-f3c8504fd43b",
          Name: "Ed_Sheeran_-_Perfect3.mp3",
        DefaultImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect3.mp3#b4e75dcd-e516-4ead-b755-f3c8504fd43b",
        HighResImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect3.mp3",
        ImageType: 11,
        CropOption: 0,
        ImageThumbnailPath: "https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-Ed_Sheeran_-_Perfect3.mp3",
        ImageThumbnailPathV2: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect3.mp3#b4e75dcd-e516-4ead-b755-f3c8504fd43b",
        ImageThumbnailPathV2Width: 0,
        ImageThumbnailPathV2Height: 0,
        HighResV2Width: 0,
        HighResV2Height: 0,
        Description: null
    },
    {
      Id: "ac9b537c-d0a0-4999-9d0e-2837f2987b93",
          Name: "Ed_Sheeran_-_Perfect2.mp3",
        DefaultImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect2.mp3#ac9b537c-d0a0-4999-9d0e-2837f2987b93",
        HighResImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect2.mp3",
        ImageType: 11,
        CropOption: 0,
        ImageThumbnailPath: "https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-Ed_Sheeran_-_Perfect2.mp3",
        ImageThumbnailPathV2: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect2.mp3#ac9b537c-d0a0-4999-9d0e-2837f2987b93",
        ImageThumbnailPathV2Width: 0,
        ImageThumbnailPathV2Height: 0,
        HighResV2Width: -1,
        HighResV2Height: 0,
        Description: null
    },
    {
      Id: "0f9a80cc-d100-4708-aca8-3c344bd34fe4",
          Name: "sample-6s8.mp3",
        DefaultImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/sample-6s8.mp3#0f9a80cc-d100-4708-aca8-3c344bd34fe4",
        HighResImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/sample-6s8.mp3",
        ImageType: 11,
        CropOption: 0,
        ImageThumbnailPath: "https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-sample-6s8.mp3",
        ImageThumbnailPathV2: "https://www.bankmarketingcenter.com/temp/uploadedimages/sample-6s8.mp3#0f9a80cc-d100-4708-aca8-3c344bd34fe4",
        ImageThumbnailPathV2Width: 0,
        ImageThumbnailPathV2Height: 0,
        HighResV2Width: -1,
        HighResV2Height: 0,
        Description: null
    },
    {
      Id: "3e9d2741-a9f7-4783-b5a2-32a661c33dcd",
          Name: "sample-3s.mp3",
        DefaultImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/sample-3s.mp3#3e9d2741-a9f7-4783-b5a2-32a661c33dcd",
        HighResImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/sample-3s.mp3",
        ImageType: 11,
        CropOption: 0,
        ImageThumbnailPath: "https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-sample-3s.mp3",
        ImageThumbnailPathV2: "https://www.bankmarketingcenter.com/temp/uploadedimages/sample-3s.mp3#3e9d2741-a9f7-4783-b5a2-32a661c33dcd",
        ImageThumbnailPathV2Width: 0,
        ImageThumbnailPathV2Height: 0,
        HighResV2Width: -1,
        HighResV2Height: 0,
        Description: null
    }], */
      isLoading:       false,
      audios:          [],
      loader:          false,
      searchQuery:     '',
      searchAudios:    [],
      isFocused:       false,
      isFocusedOut:    false,
      isAudioSearch:   false,
      durations:       {},
      playingKey:      null,
      progress:        0,
      myGalleryAudios:
          {
            MaxLimit:     20,
            LowLimit:     0,
            isProcessing: false,
          },
    };
  },
  computed: {
    getFilteredAudios() {
      if (this.searchQuery && this.isAudioSearch) {
        return this.searchAudios;
      }
      return this.audios;
    },
    hasAudios() {
      return this.getFilteredAudios.some(audio => audio);
    },
  },
  watch: {
    audios() {
      this.preloadDurations(this.audios);
    },
    searchAudios() {
      this.preloadDurations(this.searchAudios);
    },
  },
  mounted() {
    this.previewAudio = new Audio();
    this.previewAudio.preload = 'metadata';
    this.onPreviewTime = () => {
      const duration = this.previewAudio.duration;
      this.progress = duration ? (this.previewAudio.currentTime / duration) * 100 : 0;
    };
    this.onPreviewEnded = () => {
      this.playingKey = null;
      this.progress = 0;
    };
    this.previewAudio.addEventListener('timeupdate', this.onPreviewTime);
    this.previewAudio.addEventListener('ended', this.onPreviewEnded);
    setTimeout(() => {
      this.fetchUserAudios();
      this.bindScrollToGalleryAudios();
    }, 0);
  },
  beforeDestroy() {
    this.stopPreview();
  },
  methods: {
    checkQueryValue() {
      if (!this.searchQuery.length) {
        this.isAudioSearch = false;
        this.searchAudios  = [];
      }
    },
    clearValue() {
      this.searchQuery       = '';
      this.searchAudios      = [];
      this.isAudioSearch     = false;
      this.isFocused         = false;
      this.$refs.input.value = '';
    },

    typeFocus() {
      if (this.searchQuery.length > 0) {
        this.isFocused = true;
      } else {
        this.isFocused = false;
      }
    },

    removeFocus() {
      this.isFocused = false;
    },

    focusIn() {
      this.isFocusedOut = true;
    },
    fetchMyGalleryAudiosWithKeyword() {
      this.makeLoaderVisible();
      this.myGalleryAudios.isProcessing = true;
      const urlSearchPart               = window.location.search;
      const newUrlSearchParams          = new URLSearchParams(urlSearchPart);

      const userId    = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '{00000000-0000-0000-0000-000000000000}';
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=SearchUploadedAudiosByUser&domainURL=https://${domainUrl}.com/&userId=${userId}&keyword=${this.searchQuery}`;
      /* const url = `https://dev2.wysiwyg.bankmarketingcenter.com/web_service.aspx?method=SearchUploadedAudiosByUser&domainURL=https://www.bankmarketingcenter.com/&userId=21d29854-fb88-45e6-9a12-b1f4e6c67d45&maximumRows=20&startRowIndex=0&keyword=${this.searchQuery}` */
      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', this.getMyGalleryAudiosWidthKeyword);
      oReq.addEventListener('error', (e) => {
        console.log(e);
        this.MyGalleryAudios.isProcessing = false;
        this.makeLoaderInVisible();
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    changeQueryValue(event) {
      this.searchQuery = event.target.value;
      if (this.searchQuery.length) {
        this.isAudioSearch = true;
        this.fetchMyGalleryAudiosWithKeyword();
      }
    },
    deleteAudioFromMyGallery(id) {
     //  console.log('id', id);
     // EventBus.$emit('ondeleteImageFromMyGallary', id);
     //  const indexToDelete = this.audios.findIndex((audio) => audio.Id === id);
     //
     //  if (indexToDelete !== -1) {
     //    this.audios.splice(indexToDelete, 1);
     //    console.log(`Audio with Id ${id} deleted successfully.`);
     //  }
    },
    bindScrollToGalleryAudios() {
      const galleryAudios = document.getElementById('gallery-audios');
      if (!galleryAudios) { return; }
      galleryAudios.onscroll = null;
      galleryAudios.addEventListener('scroll', () => {
        if (!this.myGalleryAudios.isProcessing && Math.round(galleryAudios.scrollTop + galleryAudios.clientHeight) >= galleryAudios.scrollHeight - 10) {
          this.makeLoaderVisible();
          this.fetchUserAudios();
        }
      });
    },
    audioKey(audio) {
      if (!audio) return '';
      return audio.Id || audio.VirtualPath || audio.Name || '';
    },
    isPlaying(audio) {
      return this.playingKey && this.playingKey === this.audioKey(audio);
    },
    formatDuration(seconds) {
      if (seconds == null || !isFinite(seconds)) return '';
      const total = Math.round(seconds);
      const minutes = Math.floor(total / 60);
      const remainder = total % 60;
      return `${minutes}:${String(remainder).padStart(2, '0')}`;
    },
    preloadDurations(list) {
      if (!this.durationRequested) this.durationRequested = {};
      (list || []).forEach((audio) => {
        if (!audio || !audio.VirtualPath) return;
        const key = this.audioKey(audio);
        if (!key || this.durationRequested[key] || this.durations[key] != null) return;
        this.durationRequested[key] = true;
        const probe = document.createElement('audio');
        probe.preload = 'metadata';
        const cleanup = () => {
          probe.removeEventListener('loadedmetadata', onLoad);
          probe.removeEventListener('error', cleanup);
          probe.src = '';
        };
        const onLoad = () => {
          if (isFinite(probe.duration)) this.$set(this.durations, key, probe.duration);
          cleanup();
        };
        probe.addEventListener('loadedmetadata', onLoad);
        probe.addEventListener('error', cleanup);
        probe.src = audio.VirtualPath;
      });
    },
    stopPreview() {
      if (!this.previewAudio) return;
      this.previewAudio.pause();
      this.previewAudio.removeEventListener('timeupdate', this.onPreviewTime);
      this.previewAudio.removeEventListener('ended', this.onPreviewEnded);
      this.previewAudio.src = '';
      this.playingKey = null;
      this.progress = 0;
    },
    togglePreview(audio) {
      if (!audio || !audio.VirtualPath || !this.previewAudio) return;
      const key = this.audioKey(audio);
      if (this.playingKey === key) {
        this.previewAudio.pause();
        this.playingKey = null;
        this.pausedKey = key;
        return;
      }
      const sameTrack = this.pausedKey === key && this.previewAudio.src;
      if (!sameTrack) {
        this.progress = 0;
        this.previewAudio.src = audio.VirtualPath;
      }
      this.pausedKey = key;
      this.playingKey = key;
      const playPromise = this.previewAudio.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(() => {
          if (this.playingKey === key) this.playingKey = null;
        });
      }
    },
    insertAudioToCanvas(audioObj) {
      const self = this;
      if (this.previewAudio) this.previewAudio.pause();
      this.playingKey = null;
      this.makeLoaderVisible();
      if (audioObj) {
        const objectURL       = audioObj.VirtualPath;
        const audioPlayer     = document.createElement('audio');
        audioPlayer.src       = objectURL;
        let durationInSeconds = null;
        audioPlayer.addEventListener('loadedmetadata', () => {
          durationInSeconds     = audioPlayer.duration;
          audioObj.audioUrl     = objectURL;
          audioObj.duration     = durationInSeconds;
          audioObj.startTime    = 0;
          audioObj.endTime      = audioObj.duration;
          audioObj.fadeIn       = 0;
          audioObj.fadeOut      = audioObj.duration;
          audioObj.trimDuration = audioObj.duration;
          EventBus.$emit(ApplicationEventTypes.Audio.ADD_NEW_AUDIO, audioObj);
          EventBus.$emit('toggleAudioLeftSectionAccordion', true);
          EventBus.$emit('selectAudioLayerFromLeftSection', true);
          self.$store.commit('setDisplayAddAudioModal', false);
          this.makeLoaderInVisible();
        });
        audioPlayer.remove();
      }
    },

    fetchUserAudios() {
      if (this.myGalleryAudios.MaxLimit != this.myGalleryAudios.LowLimit) {
        this.makeLoaderVisible();
        this.myGalleryAudios.isProcessing = true;
        const urlSearchPart               = window.location.search;
        const newUrlSearchParams          = new URLSearchParams(urlSearchPart);

        const bankId = newUrlSearchParams.has('bankId') ? newUrlSearchParams.get('bankId') : 'fde5ed9d-816f-43fd-89f3-97a542947193';
        const userId = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '{00000000-0000-0000-0000-000000000000}';

        const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
        const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=SearchUploadedAudiosByUser&domainURL=https://${domainUrl}.com/&userId=${userId}&maximumRows=${this.myGalleryAudios.MaxLimit}&startRowIndex=${this.myGalleryAudios.LowLimit}&keyword=audio`;
        /* const url = `https://dev2.wysiwyg.bankmarketingcenter.com/web_service.aspx?method=SearchUploadedAudiosByUser&domainURL=https://www.bankmarketingcenter.com/&userId=21d29854-fb88-45e6-9a12-b1f4e6c67d45&maximumRows=20&startRowIndex=0&keyword=audio` */
        console.log(url);

        const oReq = new XMLHttpRequest();
        oReq.addEventListener('load', this.loadMyGalleryAudio);
        oReq.addEventListener('error', (e) => {
          console.log(e);
          this.MyGalleryAudios              = [0];
          this.MyGalleryAudios.isProcessing = false;
          this.makeLoaderInVisible();
          console.error(e);
        });
        oReq.open('GET', url);
        oReq.send();
      }
    },
    makeLoaderVisible() {
      this.loader = true;
    },
    makeLoaderInVisible() {
      this.loader = false;
    },
    loadMyGalleryAudio(data) {
      console.log(data);
      try {
        const parser         = new DOMParser();
        const xmlParsed      = parser.parseFromString(data.target.response, 'text/xml');
        let audiosCollection = xmlParsed.getElementsByTagName('SearchUploadedAudiosByUserResult');
        audiosCollection     = JSON.parse(audiosCollection[0].innerHTML);
        if (this.myGalleryAudios.MaxLimit < audiosCollection.Count) {
          this.myGalleryAudios.LowLimit  = this.myGalleryAudios.MaxLimit;
          this.myGalleryAudios.MaxLimit += 20;
        } else {
          this.myGalleryAudios.MaxLimit = audiosCollection.Count;
        }
        if (this.myGalleryAudios.LowLimit != parseInt(audiosCollection.Count, 10)) {
          this.audios = [...this.audios, ...audiosCollection.Items];
          this.$nextTick(() => {
            const galleryAudios = document.getElementById('gallery-audios');
            if (
              galleryAudios
              && galleryAudios.scrollHeight <= galleryAudios.clientHeight + 10
            ) {
              this.fetchUserAudios();
            }
          });
        } else { // condition for checking the all total number of the image is called and there is no more api call needed
          this.myGalleryAudios.LowLimit = 0;
          this.myGalleryAudios.MaxLimit = 0;
        }
      } catch (e) {
        this.audios = [0];
        console.log('Error:loadMyGalleryImages/parseFromXml', e.message);
      } finally {
        this.myGalleryAudios.isProcessing = false;
        this.makeLoaderInVisible();
      }
    },
    getMyGalleryAudiosWidthKeyword(data) {
      try {
        const parser         = new DOMParser();
        const xmlParsed      = parser.parseFromString(data.target.response, 'text/xml');
        let audiosCollection = xmlParsed.getElementsByTagName('SearchUploadedAudiosByUserResult');
        audiosCollection     = JSON.parse(audiosCollection[0].innerHTML);
        this.searchAudios    = audiosCollection.Items;
      } catch (e) {
        console.log('Error:loadMyGalleryImages/parseFromXml', e.message);
      } finally {
        this.myGalleryAudios.isProcessing = false;
        this.makeLoaderInVisible();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.ag-gallery {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  font-family: 'Geist', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif;
  color: #14161B;
}

.ag-search-row {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}

.ag-search {
  width: 100%;
  max-width: 100%;
  height: 38px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 8px 0 12px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
  box-shadow: inset 0 0 0 1px #E7E9ED;
}

.ag-search:focus-within {
  box-shadow: inset 0 0 0 1.5px #1570EF, 0 0 0 3px rgba(21, 112, 239, 0.15);
}

.ag-search input {
  flex: 1 1 auto;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  padding: 0;
  margin: 0;
  font-family: inherit;
  font-size: 13.5px;
  color: #14161B;
  box-shadow: none;
}

.ag-search input,
.ag-search input:focus,
.ag-search-clear,
.ag-search-clear:focus,
.ag-toggle,
.ag-toggle:focus,
.ag-delete,
.ag-delete:focus {
  border: 0;
  outline: 0;
  -webkit-appearance: none;
  appearance: none;
}

.ag-search input::-webkit-search-cancel-button {
  display: none;
}

.ag-search-icon,
.ag-search-clear {
  display: flex;
  flex-shrink: 0;
  color: #5E6573;
}

.ag-search-clear {
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  padding: 0;
  cursor: pointer;
  background: transparent;
  color: #3D4350;
}

.ag-search kbd {
  font-family: 'Geist Mono', ui-monospace, 'SF Mono', Menlo, monospace;
  font-size: 10.5px;
  color: #5E6573;
  background: #F3F4F6;
  border-radius: 5px;
  padding: 2px 6px;
}

.ag-search-results {
  font-size: 12.5px;
  color: #5E6573;
}

.ag-list {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
}

.ag-empty {
  padding: 28px 8px;
  font-size: 13px;
  text-align: center;
  color: #5E6573;
}

.ag-row {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto 28px;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  padding: 8px 10px;
  border: 1.5px solid transparent;
  border-radius: 10px;
  cursor: pointer;
}

.ag-row:hover {
  background: #EAF2FE;
  border-color: #1570EF;
}

.ag-toggle {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 50%;
  background: #fff;
  box-shadow: inset 0 0 0 1.5px #1570EF;
  color: #1570EF;
  cursor: pointer;
}

.ag-toggle.is-playing {
  background: #1570EF;
  box-shadow: none;
  color: #fff;
}

.ag-main {
  min-width: 0;
}

.ag-name {
  display: block;
  overflow: hidden;
  font-size: 14px;
  line-height: 1.3;
  color: #14161B;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ag-progress {
  display: block;
  height: 3px;
  margin-top: 6px;
  overflow: hidden;
  border-radius: 99px;
  background: #E7E9ED;
}

.ag-progress > span {
  display: block;
  height: 100%;
  border-radius: 99px;
  background: #1570EF;
}

.ag-time {
  font-size: 13px;
  line-height: 1;
  color: #5E6573;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.ag-delete {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 7px;
  background: transparent;
  color: #8B919C;
  cursor: pointer;
}

.ag-delete:hover {
  background: #F3F4F6;
  color: #3D4350;
}

.ag-search ::v-deep .icon,
.ag-delete ::v-deep .icon {
  min-width: 0;
  min-height: 0;
  color: inherit;
}

.ag-search-icon ::v-deep .icon svg {
  display: block;
  width: 16px;
  height: 16px;
}

.ag-search-clear ::v-deep .icon svg {
  display: block;
  width: 14px;
  height: 14px;
}

.ag-delete ::v-deep svg {
  display: block;
  width: 16px;
  height: 16px;
}

.inner-Loader {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.72);
}
</style>
